import React from 'react';

import { Title } from 'components/Title';
import { Text } from 'components/Text';
import { Link } from 'react-router-dom';
import { Routes } from 'core/routes.types';
import { Button } from 'components';
import { Container } from './NotFound.style';

const NotFound: React.FunctionComponent = () => {
    return (
        <Container>
            <Title text="Oops..." weight="bold" noTranslation />
            <Text text="notFound_message" weight="regular" />
            <Link to={Routes.Home}>
                <Button fullWidth>
                    <Text text="notFound_backToHome" />
                </Button>
            </Link>
        </Container>
    );
};

export default NotFound;
